export function getEnumOptions(enumClass): number[] {
  return Object.keys(enumClass)
    .map(v => enumClass[v])
    .filter(v => isNaN(+v) === false)
    .map(v => +v);
}

